export const CAMPAIGN_STATUSES = [
  { value: "", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "paused", label: "Paused" },
  { value: "completed", label: "Completed" },
];

export const STATUS_COLORS = {
  draft: "#6b7280",
  active: "#10b981",
  paused: "#f59e0b",
  completed: "#6366f1",
};

export const GENDER_OPTIONS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "other", label: "Other" },
  { value: "all", label: "All" },
];

export const AGE_RANGE_OPTIONS = [
  { value: "18-24", label: "18-24" },
  { value: "25-34", label: "25-34" },
  { value: "35-44", label: "35-44" },
  { value: "45+", label: "45+" },
];

export const PLACEMENT_OPTIONS = [
  { value: "feed", label: "Feed" },
  { value: "auditions_feed", label: "Auditions Feed" },
  { value: "search_results", label: "Search Results" },
  { value: "profile_banner", label: "Profile Banner" },
  { value: "messages_top", label: "Messages Top" },
  { value: "home_banner", label: "Home Banner" },
  { value: "splash_screen", label: "Splash Screen" },
];

export const AD_TYPE_OPTIONS = [
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
];

export const toDatetimeLocal = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromDatetimeLocal = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
};

export const formatCurrency = (n) => {
  if (n === null || n === undefined || n === "") return "—";
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(n));
};

export const formatNumber = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("en-IN");
};

export const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-IN", {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

export const formatPercent = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return `${Number(n).toFixed(2)}%`;
};

export const normalizePlacements = (placements) =>
  (placements || [])
    .map((p) => (typeof p === "string" ? p.trim() : p?.value?.trim?.() || ""))
    .filter(Boolean);

/** API uses `id` as the advertisement UUID in list/detail responses. */
export const getAdUuid = (ad) => {
  if (!ad) return null;
  if (ad.id != null && String(ad.id).trim()) return String(ad.id).trim();
  const candidates = [ad.uuid, ad.ad_uuid, ad.advertisement_uuid, ad.pk];
  for (const c of candidates) {
    if (c != null && String(c).trim()) return String(c).trim();
  }
  return null;
};

export const getAdUuidFromResponse = (response) => {
  const fromBody = getAdUuid(response?.data);
  if (fromBody) return fromBody;
  const location = response?.headers?.location || response?.headers?.Location;
  if (location) {
    const match = String(location).match(/advertisements\/([^/]+)\/?$/i);
    if (match?.[1]) return match[1];
  }
  return null;
};

export const buildAdvertisementPayload = (adForm) => {
  const placements = normalizePlacements(adForm.placements);
  const payload = {
    title: adForm.title.trim(),
    ad_type: adForm.ad_type,
    cta_text: adForm.cta_text || "Know More",
    destination_url: adForm.destination_url.trim(),
    is_active: Boolean(adForm.is_active),
  };
  if (adForm.description?.trim()) payload.description = adForm.description.trim();
  if (placements.length) payload.placements = placements;
  return payload;
};

/** Multipart body for banner image upload only (avoids multipart placements parsing issues). */
export const buildBannerFormData = (file) => {
  const fd = new FormData();
  fd.append("banner_image", file);
  return fd;
};

export const formatApiError = (err, fallback = "Something went wrong.") => {
  const data = err?.response?.data;
  if (!data) return fallback;
  if (typeof data.detail === "string") return data.detail;
  if (Array.isArray(data.detail)) return data.detail.join(" ");
  const messages = Object.entries(data).flatMap(([field, msgs]) => {
    if (Array.isArray(msgs)) return msgs.map((m) => `${field}: ${m}`);
    if (msgs && typeof msgs === "object") {
      return Object.entries(msgs).flatMap(([key, val]) =>
        (Array.isArray(val) ? val : [val]).map((m) => `${field}.${key}: ${m}`)
      );
    }
    return [`${field}: ${msgs}`];
  });
  return messages.length ? messages.join(" ") : fallback;
};
